import { Typography } from '@mui/material';

export const FilterSelectedLabel = (more: number) => (
  <Typography variant="paragraph">{`${more} ausgewählt`}</Typography>
);
